import { createApp } from 'vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'
import money from 'v-money'

// import stores from './stores'
// import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import App from './App.vue'

import createRouter from './router'
import { createResources } from '@/commons/helpers'
import { createPinia } from 'pinia'
import Store from './stores/store'

import PrimeVue from "primevue/config";
import Noir from "./presents/Noir.js";

const api = createResources()

const app = createApp(App)
const pinia = createPinia()
pinia.use(() => ({ $api: api }))

app.use(pinia)
const store = new Store()
const router = createRouter(store)

// app.use(stores)
app.use(router)
app.use(i18n)
app.use(money, { precision: 2 })
app.use(createVuestic({ config: vuesticGlobalConfig }))
app.use(PrimeVue, {
    locale: {firstDayOfWeek: 1},
    theme: {
        preset: Noir,
        options: {
            prefix: 'p',
            darkModeSelector: '.p-dark',
            cssLayer: false,
        }
    }
});

app.config.globalProperties.$store = store;
app.config.globalProperties.$api = createResources()

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')
